import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "@/config";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-bone/80 border-b border-[#E5E0D8]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex flex-col leading-none">
          <span className="font-serif-display text-2xl text-text-main">{BUSINESS.name}</span>
          <span className="overline mt-1">{BUSINESS.tagline}</span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-accent text-sm text-text-main hover:text-cedar transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            data-testid="nav-cta-book"
            href="#book"
            className="inline-flex items-center rounded-full bg-cedar text-white hover:bg-cedar-hover px-6 py-3 font-accent text-sm tracking-wide transition-colors"
          >
            Request a Quote
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-text-main"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-bone border-t border-[#E5E0D8]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="font-accent text-base text-text-main hover:text-cedar"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#book"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="mt-2 inline-flex justify-center items-center rounded-full bg-cedar text-white px-6 py-3 font-accent text-sm"
            >
              Request a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
